export default __webpack_public_path__ + "static/media/application.3a8a5120.svg";